<template>
  <router-link
    v-if="isAuthorized"
    v-bind="$attrs"
    v-on="$listeners"
    :to="to"
  >
    <slot />
  </router-link>
  <span v-else>
    <slot />
  </span>
</template>

<script>
export default {
  name: 'RouterLinkGuard',
  inheritAttrs: false,
  props: {
    to: {
      type: [String, Object],
      required: true
    },
    can: {
      type: String,
      default: null
    }
  },
  computed: {
    isAuthorized () {
      if (this.can) return this.$store.getters.can(this.can)
      const resolved = this.$router.resolve(this.to)
      const permission = resolved?.route?.meta?.permission
      return permission ? this.$store.getters.can(permission) : true
    }
  }
}
</script>
